import * as i0 from '@angular/core';
import { signal, inject, Injectable, computed, Component, ChangeDetectionStrategy, Optional, Inject, HostListener, input, output } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subject } from 'rxjs';
import { NgComponentOutlet } from '@angular/common';
import { NgxIcon } from '@digipay/ngx-icon';
const _c0 = (a0, a1, a2) => ({
  open: a0,
  "opacity-full": a1,
  "no-padding": a2
});
const _c1 = (a0, a1) => ({
  open: a0,
  "opacity-full": a1
});
const _c2 = a0 => ({
  height: a0
});
const _c3 = (a0, a1) => ({
  open: a0,
  "bg-primary": a1
});
function NgxBottomSheetComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c4 = ["*"];
function NgxBottomSheetHeaderComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 1);
  }
}
function NgxBottomSheetHeaderComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngx-icon", 6);
    i0.ɵɵlistener("click", function NgxBottomSheetHeaderComponent_Conditional_4_Template_ngx_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleCloseClicked());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("name", "close");
  }
}
function NgxBottomSheetHeaderComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.title());
  }
}
function NgxBottomSheetHeaderComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
let NgxBottomSheetService = /*#__PURE__*/(() => {
  class NgxBottomSheetService {
    constructor() {
      this.isVisibleContent = signal(false);
      this.isVisibleContainers = signal(false);
      this.component = signal(null);
      this.data = signal(null);
      this.outputData = signal(null);
      this.config = signal(undefined);
      this.isOpening = signal(false);
      this.router = inject(Router);
      this.onClose = new Subject();
      this.emittedValue = 0;
    }
    openBottomSheet(component, data, config = null) {
      this.outputData.set(null);
      this.data.set(data);
      this.component.set(component);
      this.isVisibleContent.set(true);
      this.isVisibleContainers.set(true);
      if (config) {
        this.config.set(config);
      }
      this.isOpening.set(true);
      this.routingSubscriber?.unsubscribe();
      if (!config || !config.notCloseOnChangeRoute) {
        this.routingSubscriber = this.router.events.subscribe(event => {
          if (event instanceof NavigationStart) {
            this.closeBottomSheet();
          }
        });
      }
      setTimeout(() => {
        this.isOpening.set(false);
      }, 100);
    }
    closeBottomSheet() {
      this.routingSubscriber?.unsubscribe();
      this.isVisibleContent.set(false);
      setTimeout(() => {
        this.data.set(null);
        this.config.set(undefined);
        this.component.set(null);
        this.isVisibleContainers.set(false);
        this.emittedValue++;
        this.onClose.next({
          value: this.emittedValue
        });
      }, 300);
    }
    static {
      this.ɵfac = function NgxBottomSheetService_Factory(t) {
        return new (t || NgxBottomSheetService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NgxBottomSheetService,
        factory: NgxBottomSheetService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NgxBottomSheetService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxBottomSheetComponent = /*#__PURE__*/(() => {
  class NgxBottomSheetComponent {
    constructor(bottomSheet) {
      this.bottomSheet = bottomSheet;
      this.isVisibleContent = computed(() => this.bottomSheetInstance().isVisibleContent() ?? false);
      this.isVisibleContainers = computed(() => this.bottomSheetInstance().isVisibleContainers() ?? false);
      this.component = computed(() => this.bottomSheetInstance().component());
      this.config = computed(() => this.bottomSheetInstance().config() ? this.bottomSheetInstance().config() : null);
      this.bottomSheetService = inject(NgxBottomSheetService);
      this.bottomSheetInstance = computed(() => {
        if (this.bottomSheet.data()) {
          return this.bottomSheet;
        } else {
          return this.bottomSheetService;
        }
      });
    }
    click(event) {
      if (this.config()?.disableClose) {
        return;
      }
      if (event.target.classList.contains('bottom-sheet-container')) {
        if (!this.bottomSheetInstance().isOpening()) {
          this.bottomSheetInstance().closeBottomSheet();
        }
      }
    }
    static {
      this.ɵfac = function NgxBottomSheetComponent_Factory(t) {
        return new (t || NgxBottomSheetComponent)(i0.ɵɵdirectiveInject('STATE_BOTTOM_SHEET', 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxBottomSheetComponent,
        selectors: [["ngx-bottom-sheet"]],
        hostBindings: function NgxBottomSheetComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function NgxBottomSheetComponent_click_HostBindingHandler($event) {
              return ctx.click($event);
            });
          }
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 4,
        vars: 23,
        consts: [[1, "all-width-container"], [1, "bottom-sheet-container", "no-select"], [1, "bottom-sheet-content", "surface-elevated"], [4, "ngComponentOutlet"]],
        template: function NgxBottomSheetComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵtemplate(3, NgxBottomSheetComponent_ng_container_3_Template, 1, 0, "ng-container", 3);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            let tmp_0_0;
            let tmp_2_0;
            let tmp_3_0;
            let tmp_4_0;
            i0.ɵɵclassMap(i0.ɵɵpureFunction3(11, _c0, ctx.isVisibleContainers(), ctx.isVisibleContent(), (tmp_0_0 = ctx.config()) == null ? null : tmp_0_0.noPadding));
            i0.ɵɵadvance();
            i0.ɵɵclassMap(i0.ɵɵpureFunction2(15, _c1, ctx.isVisibleContainers(), ctx.isVisibleContent()));
            i0.ɵɵstyleProp("max-width", (tmp_2_0 = ctx.config()) == null ? null : tmp_2_0.maxWidth);
            i0.ɵɵadvance();
            i0.ɵɵstyleMap(i0.ɵɵpureFunction1(18, _c2, (tmp_3_0 = ctx.config()) == null ? null : tmp_3_0.height));
            i0.ɵɵclassMap(i0.ɵɵpureFunction2(20, _c3, ctx.isVisibleContent(), !ctx.config() || !((tmp_4_0 = ctx.config()) == null ? null : tmp_4_0.hasBackgroundColor)));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngComponentOutlet", ctx.component());
          }
        },
        dependencies: [NgComponentOutlet],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.all-width-container[_ngcontent-%COMP%]{position:fixed;height:100%;width:100%;top:0;right:0;z-index:1000;transform:translate(200%);opacity:0;transition:opacity .3s ease-in-out}.all-width-container[_ngcontent-%COMP%]   .bottom-sheet-header[_ngcontent-%COMP%]{height:60px}.all-width-container[_ngcontent-%COMP%]   .bottom-sheet-header[_ngcontent-%COMP%]   .line[_ngcontent-%COMP%]{width:40px;height:4px}.all-width-container[_ngcontent-%COMP%]   .bottom-sheet-header[_ngcontent-%COMP%]   .header-title-section[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between}.all-width-container.open[_ngcontent-%COMP%]{transform:translate(0);display:flex;justify-content:center}.all-width-container.opacity-full[_ngcontent-%COMP%]{opacity:1}.all-width-container[_ngcontent-%COMP%]   .bottom-sheet-container[_ngcontent-%COMP%]{max-width:var(--container-width-large);position:absolute;height:100%;width:100%;top:0;background:#424c5c99;z-index:3;transform:translate(200%);overflow:hidden;opacity:0;transition:opacity .3s ease-in-out}.all-width-container[_ngcontent-%COMP%]   .bottom-sheet-container.open[_ngcontent-%COMP%]{transform:translate(0);display:block}.all-width-container[_ngcontent-%COMP%]   .bottom-sheet-container.opacity-full[_ngcontent-%COMP%]{opacity:1}.all-width-container[_ngcontent-%COMP%]   .bottom-sheet-container[_ngcontent-%COMP%]   .bottom-sheet-content[_ngcontent-%COMP%]{position:absolute;bottom:0;padding:32px 20px;z-index:1000;width:100%;border-radius:24px 24px 0 0;transform:translateY(700px);transition:all .3s ease-in-out;max-height:100%;overflow:hidden;box-sizing:border-box}.all-width-container[_ngcontent-%COMP%]   .bottom-sheet-container[_ngcontent-%COMP%]   .bottom-sheet-content.open[_ngcontent-%COMP%]{transform:translateY(0)}.all-width-container.no-padding[_ngcontent-%COMP%]   .bottom-sheet-container[_ngcontent-%COMP%]   .bottom-sheet-content[_ngcontent-%COMP%]{padding:0!important}"],
        changeDetection: 0
      });
    }
  }
  return NgxBottomSheetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxBottomSheetHeaderComponent = /*#__PURE__*/(() => {
  class NgxBottomSheetHeaderComponent {
    constructor() {
      this.title = input('');
      this.showTitle = input(true);
      this.closeIcon = input(false);
      this.leftButton = input(false);
      this.showResizable = input(false);
      this.closeClicked = output();
    }
    handleCloseClicked() {
      this.closeClicked.emit(true);
    }
    static {
      this.ɵfac = function NgxBottomSheetHeaderComponent_Factory(t) {
        return new (t || NgxBottomSheetHeaderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxBottomSheetHeaderComponent,
        selectors: [["ngx-bottom-sheet-header"]],
        inputs: {
          title: [i0.ɵɵInputFlags.SignalBased, "title"],
          showTitle: [i0.ɵɵInputFlags.SignalBased, "showTitle"],
          closeIcon: [i0.ɵɵInputFlags.SignalBased, "closeIcon"],
          leftButton: [i0.ɵɵInputFlags.SignalBased, "leftButton"],
          showResizable: [i0.ɵɵInputFlags.SignalBased, "showResizable"]
        },
        outputs: {
          closeClicked: "closeClicked"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c4,
        decls: 7,
        vars: 4,
        consts: [[1, "bottom-sheet-header", "pt-small", "border-b-300", "border-color-light", "rtl"], [1, "line", "mx-auto", "radius-giant", "surface-back"], [1, "d-flex", "justify-content-space-between", "px-plus", "py-small"], [1, "d-flex", "gap-pony", "align-items-center"], ["iconSize", "20px", "classes", "text-onback-brand cursor-pointer", 3, "name"], [1, "text-onback-high", "st-6"], ["iconSize", "20px", "classes", "text-onback-brand cursor-pointer", 3, "click", "name"]],
        template: function NgxBottomSheetHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, NgxBottomSheetHeaderComponent_Conditional_1_Template, 1, 0, "div", 1);
            i0.ɵɵelementStart(2, "div", 2)(3, "div", 3);
            i0.ɵɵtemplate(4, NgxBottomSheetHeaderComponent_Conditional_4_Template, 1, 1, "ngx-icon", 4)(5, NgxBottomSheetHeaderComponent_Conditional_5_Template, 2, 1, "span", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, NgxBottomSheetHeaderComponent_Conditional_6_Template, 1, 0);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(1, ctx.showResizable() ? 1 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(4, ctx.closeIcon() ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(5, ctx.showTitle() ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(6, ctx.leftButton() ? 6 : -1);
          }
        },
        dependencies: [NgxIcon],
        styles: [".bottom-sheet-header[_ngcontent-%COMP%]{min-height:52px}.bottom-sheet-header[_ngcontent-%COMP%]   .line[_ngcontent-%COMP%]{width:40px;height:4px}"],
        changeDetection: 0
      });
    }
  }
  return NgxBottomSheetHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgxBottomSheetComponent, NgxBottomSheetHeaderComponent, NgxBottomSheetService };
